export default "/assets/images/award-img-03.png?921a6fd30a4265fc0f4e9e72e67b01f0";